module.exports = __webpack_public_path__ + "img/epiImage.e95b7daa.svg";